var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t(`admin.${this.type}`),
        "close-on-click-modal": false,
        visible: true,
        width: "400px",
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        { staticClass: "flex item-center" },
        [
          _c("i", { staticClass: "required-cls" }, [_vm._v("*")]),
          _vm.type === "entityName"
            ? _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", filterable: "" },
                model: {
                  value: _vm.entityName,
                  callback: function ($$v) {
                    _vm.entityName = $$v
                  },
                  expression: "entityName",
                },
              })
            : _vm.type === "signingDate"
            ? _c("el-date-picker", {
                staticClass: "w-full",
                attrs: { "value-format": "yyyy-MM-dd", type: "date" },
                model: {
                  value: _vm.signingDate,
                  callback: function ($$v) {
                    _vm.signingDate = $$v
                  },
                  expression: "signingDate",
                },
              })
            : _c("el-input", {
                staticStyle: { width: "100%" },
                attrs: { clearable: "", filterable: "" },
                model: {
                  value: _vm.description,
                  callback: function ($$v) {
                    _vm.description = $$v
                  },
                  expression: "description",
                },
              }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "wl-green", on: { click: _vm.onConfirmHere } },
            [_vm._v(_vm._s(_vm.$t("btn_submit")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }